const apilist = {
    division_option : {
        url:"/api/sparepart/division",
        auth:true,
        method:'GET'
    },
    shift_option : {
        url:"/api/sparepart/shift",
        auth:true,
        method:'GET'
    },
    machine_option : {
        url:"/api/machine/search",
        auth:true,
        method:'GET'
    },
    sparepart_option : {
        url:"/api/sparepart/optionslist",
        auth:true,
        method:'GET'
    },
    listrik_list : {
        url:"/api/electicity_usage/list",
        auth:true,
        method:'GET'
    },
    listrik_chart : {
        url:"/api/electicity_usage/chart",
        auth:true,
        method:'GET'
    },
    listrik_add : {
        url:"/api/electicity_usage/add",
        auth:true,
        method:'POST'
    },
    listrik_preview : {
        url:"/api/electicity_usage/preview",
        auth:true,
        method:'POST'
    },
    gas_list : {
        url:"/api/gas_usage/list",
        auth:true,
        method:'GET'
    },
    gas_chart : {
        url:"/api/gas_usage/chart",
        auth:true,
        method:'GET'
    },
    gas_preview : {
        url:"/api/gas_usage/preview",
        auth:true,
        method:'POST'
    },
    gas_add : {
        url:"/api/gas_usage/add",
        auth:true,
        method:'POST'
    },
    air_list : {
        url:"/api/water_usage/list",
        auth:true,
        method:'GET'
    },
    air_chart : {
        url:"/api/water_usage/chart",
        auth:true,
        method:'GET'
    },
    air_add : {
        url:"/api/water_usage/add",
        auth:true,
        method:'POST'
    },
    air_preview : {
        url:"/api/water_usage/preview",
        auth:true,
        method:'POST'
    },
    kue_list : {
        url:"/api/cake_production/list",
        auth:true,
        method:'GET'
    },
    kue_chart : {
        url:"/api/cake_production/chart",
        auth:true,
        method:'GET'
    },
    kue_add : {
        url:"/api/cake_production/add",
        auth:true,
        method:'POST'
    },
    kue_preview : {
        url:"/api/cake_production/preview",
        auth:true,
        method:'POST'
    },
    sparepart_list : {
        url:"/api/sparepart/list",
        auth:true,
        method:'GET'
    },
    sparepart_chart : {
        url:"/api/sparepart/chart",
        auth:true,
        method:'GET'
    },
    sparepart_add : {
        url:"/api/sparepart/add",
        auth:true,
        method:'POST'
    },
    downtime_list : {
        url:"/api/downtime/list",
        auth:true,
        method:'GET'
    },
    downtime_chart : {
        url:"/api/downtime/chart",
        auth:true,
        method:'GET'
    },
    downtime_add : {
        url:"/api/downtime/add",
        auth:true,
        method:'POST'
    },
    downtime_process : {
        url:"/api/downtime/proccess",
        auth:true,
        method:'POST'
    },
    downtime_detail : {
        url:"/api/downtime/detail",
        auth:true,
        method:'GET'
    },
}

const APIURL = process.env.VUE_APP_SALUTARIA_API_URL;

export const api = (key, options = {}) => {
    return new Promise((resolve, reject) => {
        try {
            let api_bp = apilist[key];
            let therest = {};
            let params = "";
            let route = "";
            therest.headers = {};

            if (Object.prototype.hasOwnProperty.call(options, "params"))
                params = "?" + new URLSearchParams(options.params).toString();
            
            if (api_bp.auth)
                therest.headers["Authorization"] = "Bearer " + localStorage.authToken;
            
            if (Object.prototype.hasOwnProperty.call(options, "body") &&
                options.body instanceof File) {
                const formData = new FormData();
                formData.append("file", options.body);
                therest.body = formData;
            } else if (Object.prototype.hasOwnProperty.call(options, "body")) {
                therest.headers["Content-Type"] = "application/json";
                therest.body = JSON.stringify(options.body);
            }

            if (Object.prototype.hasOwnProperty.call(options, "route")) route = options.route;

            fetch(APIURL + api_bp.url + route + params, {
                method: api_bp.method,
                ...therest,
            })
            .then(response => response.json())
            .then(result => {
                if (result.code === 401) {
                    // logout();
                    // location.reload();
                    reject(result);
                    return;
                }
                if (result.code === 422) {
                    reject(result);
                    return;
                }

                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
        } catch (error) {
            reject(error);
        }
    });
};
export const num = (num = 0) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const nom = (num = 0) => {
    return parseFloat(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};